module.exports = __webpack_public_path__ + "static/scale-model-of-downtown-golden-in-lakewood-colorado-a797615546e15419557c75e0c5349fd6.png";